// @ts-check

/**
 * Serializes the currently open canvas document into the `<canvas_documents>`
 * XML-like string expected by the `/canvas_agent` request body.
 *
 * @param {{ _id: string, title?: string, currentVersion?: { content?: string }, pendingDiffs?: { status: string }[] } | null | undefined} canvasDoc
 * @returns {string | undefined}
 */
function serializeCanvasDocuments(canvasDoc) {
  if (!canvasDoc?._id) return undefined

  const title = canvasDoc.title ?? "Untitled"
  const content = canvasDoc.currentVersion?.content ?? ""
  const pendingSuggestions = (canvasDoc.pendingDiffs ?? []).filter((d) => d.status === "pending").length

  return (
    `<canvas_documents>\n` +
    `<document id="${canvasDoc._id}" title="${title}" pending_suggestions="${pendingSuggestions}">\n` +
    `${content}\n` +
    `</document>\n` +
    `</canvas_documents>`
  )
}

export { serializeCanvasDocuments }
